import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from 'lucide-react'
import {
  useCallback,
  useState,
} from 'react'

import Button from 'components/Button'
import Text from 'components/typography/Text'

import GuideStepRating from './GuideStepRating'

export interface Props {
  canGoBack: boolean
  onBackClick?: () => void
  canGoNext: boolean
  onNextClick?: () => void
  backTitle: string
  nextTitle: string
}

function BottomNavigation({
  canGoBack,
  onBackClick,
  canGoNext,
  onNextClick,
  backTitle,
  nextTitle,
}: Props) {
  const [tooltip, setTooltip] = useState('')

  const handleBackClick = useCallback(() => {
    setTooltip('')
    onBackClick?.()
  }, [onBackClick])

  const handleNextClick = useCallback(() => {
    setTooltip('')
    onNextClick?.()
  }, [onNextClick])

  return (
    <div className="
      p-2
      border-t
      border-gray-800
      bg-gray-800/20
      relative
      flex
      items-center
    ">
      <div className="
        flex-1
        flex
        items-center
        justify-between
        mx-auto
        w-full
      ">
        <div className={`
          flex-1
          flex
          justify-between
          items-center
          relative
        `}>
          {tooltip &&
            <div className="
              absolute
              bottom-full
              left-1/2
              -translate-x-1/2
              mb-[14px]
              p-2
              transition-all
              rounded-lg
              border
              border-gray-500/20
              bg-gray-800
              whitespace-nowrap
              shadow-guide-navigation
              z-50
            ">
              <div className="
                relative
                bottom-px
                flex
                items-center
                space-x-1
              ">
                <Text
                  color="text-gray-600"
                  size={Text.size.sm}
                  text={tooltip === backTitle ? 'Back:' : 'Next:'}
                  typeface={Text.typeface.InterMedium}
                />
                <Text
                  color="text-gray-200"
                  text={tooltip}
                  typeface={Text.typeface.InterMedium}
                />
              </div>
            </div>
          }

          {canGoBack ?
            <Button
              icon={<ChevronLeftIcon size={18}/>}
              iconPosition={Button.iconPosition.Left}
              text="Back"
              textSize={Button.textSize.xs}
              version={Button.version.SecondaryGreen}
              onClick={handleBackClick}
              onMouseEnter={() => setTooltip(backTitle)}
              onMouseLeave={() => setTooltip('')}
            />
            : <div className="w-[67.813px]"/>
          }

          <GuideStepRating/>

          {canGoNext &&
            <Button
              icon={<ChevronRightIcon size={18}/>}
              iconPosition={Button.iconPosition.Right}
              text="Next"
              textSize={Button.textSize.xs}
              version={Button.version.SecondaryGreen}
              onClick={handleNextClick}
              onMouseEnter={() => setTooltip(nextTitle)}
              onMouseLeave={() => setTooltip('')}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default BottomNavigation
